import { ApplicationFileType } from '../enums';

export interface ApplicationFile {
  id: string;
  name: string;
  size: number;
  type: ApplicationFileType;
}

export namespace ApplicationFile {
  export function mapFromApiValue({ type, ...restOfApplicationFile }: any): ApplicationFile {
    return {
      ...restOfApplicationFile,
      type: ApplicationFileType.mapFromApiValue(type),
    };
  }
}
